import {Col, Row} from "reactstrap";
import Skeleton from "@material-ui/lab/Skeleton";

const ContactUsSkeleton = () => {
    return (
        <Row>
            <Col sm={12} md={6}>
                <Skeleton variant="rect" height={400} className="mr-1"/>
            </Col>

            <Col sm={12} md={6}>
                <Skeleton variant="rect" height={400} className="ml-1"/>
            </Col>

            <Col sm={12} md={12}>
                <Skeleton variant="rect" width="100%" height={100} className="mt-2"/>
            </Col>
        </Row>
    );
}

export default ContactUsSkeleton;